import { connect } from 'react-redux'
import Document from './Document.jsx'
import { getCurrentMediaProps } from 'redux/mediaList/selectors'
import { currentMediaSourceLoaded } from 'redux/currentMedia/actions'

const mapStateToProps = (state, ownProps) => ({
    ...getCurrentMediaProps(state),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    sourceLoaded: () => dispatch(currentMediaSourceLoaded(ownProps.id)),
})

export const DocumentContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Document)
